import type { ReactNode } from 'react'
import { haptic } from '../telegram/haptics.ts'
import { IconClose } from './icons.tsx'

interface ChipProps {
  children: ReactNode
  selected?: boolean
  warn?: boolean
  count?: number
  icon?: ReactNode
  onClick?: () => void
  onRemove?: () => void
  ariaLabel?: string
}

export function Chip({ children, selected, warn, count, icon, onClick, onRemove, ariaLabel }: ChipProps) {
  const cls = `chip${selected ? ' chip--selected' : ''}${warn && !selected ? ' chip--warn' : ''}`
  if (onRemove) {
    return (
      <span className={cls}>
        {icon}
        {children}
        <button
          type="button"
          className="chip__remove"
          aria-label={`Убрать ${String(children)}`}
          onClick={onRemove}
        >
          <IconClose size={14} strokeWidth={2.2} />
        </button>
      </span>
    )
  }
  return (
    <button
      type="button"
      className={cls}
      aria-pressed={selected}
      aria-label={ariaLabel}
      onClick={() => {
        haptic.selection()
        onClick?.()
      }}
    >
      {icon}
      {children}
      {count !== undefined && count > 0 && <span className="chip__count">{count}</span>}
    </button>
  )
}

export interface FilterOption<T extends string> {
  value: T
  label: string
  count?: number
  warn?: boolean
}

interface FilterChipsProps<T extends string> {
  options: FilterOption<T>[]
  value: T
  onChange: (v: T) => void
  label: string
}

/** Горизонтальная лента фильтров (одиночный выбор). */
export function FilterChips<T extends string>({ options, value, onChange, label }: FilterChipsProps<T>) {
  return (
    <div className="chips" role="toolbar" aria-label={label}>
      {options.map((o) => (
        <Chip
          key={o.value}
          selected={o.value === value}
          count={o.count}
          warn={o.warn}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </Chip>
      ))}
    </div>
  )
}
